// extracted by css-extract-rspack-plugin
export default {"CreateTabButton":"wgrrq"};